import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment, endpoints } from '@environment';
import { ConfirmDeleteRequest, Profile } from '@core/models';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.authApiUrl}/${endpoints.auth.v1.profile}`;

  getProfile(): Observable<Profile> {
    return this.http.get<Profile>(this.baseUrl);
  }

  confirmDelete(request: ConfirmDeleteRequest): Observable<void> {
    const body: ConfirmDeleteRequest = {};
    if (request.app !== undefined) {
      body.app = request.app;
    }
    if (request.twoFactorAuthorizationToken !== undefined) {
      body.twoFactorAuthorizationToken = request.twoFactorAuthorizationToken;
    }

    return this.http.post<void>(
      `${environment.authApiUrl}/${endpoints.auth.v1.profileConfirmDelete}`,
      body,
    );
  }

  deleteAccount(code: string, app?: string): Observable<void> {
    const body: { code: string; app?: string } = { code };
    if (app) {
      body.app = app;
    }
    return this.http.post<void>(
      `${environment.authApiUrl}/${endpoints.auth.v1.profileDelete}`,
      body,
    );
  }
}
